import { useState, useEffect, memo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import queryString from "query-string";

import { jwt, useSnackbar } from "../utils/index.js";
import api from "../api/index.js";

const Auth = () => {
	const location = useLocation();
	const { error: error_ } = useSnackbar();
	const [redirectTo, setRedirectTo] = useState("/home");
	const { error: queryError, token: queryToken } = queryString.parse(location.search);

	useEffect(() => {
		try {
			setRedirectTo((p) => JSON.parse(sessionStorage.getItem("redirectTo")) || p);
			sessionStorage.removeItem("redirectTo");
		} catch { /** empty */ }
	}, []);

	const [state, setState] = useState({ user: null, error: null, success: false });
	const [error, setError] = useState(queryError || null);

	useEffect(() => {
		let isMounted = true;

		(async () => {
			try {
				const { token, error: err } = queryString.parse(location.search);
				if (error) {
					setError(err);
				} else if (!token) {
					if (isMounted) setState({ user: null, error: null, success: false });
				} else {
					jwt.setToken(token);
					const usr = await api.get("user/attempt-auth/");
					if (isMounted) setState({ user: usr, error: null, success: true });
				}
			} catch {
				error_();
			}
		})();

		return () => { isMounted = false; };
	}, [error, error_, location.search]);

	if (error) return (<Navigate replace to="/" state={{ error }} />);
	if (!queryToken) return <Navigate replace to="/" />;
	if (!state.success) return <div />;
	return state.success ? <Navigate replace to={redirectTo} /> : <Navigate replace to="/" />;
};

export default memo(Auth);
